import { graphql } from '../../gql';

export const ORDERS_QUERY = graphql(`
  query SellerOrders(
    $filter: String
    $first: Int
    $after: String
    $before: String
    $sellerOrderStatus: [SellerOrderStatus!]
    $orderedAfter: Date
    $orderedBefore: Date
    $totalMin: Float
    $totalMax: Float
  ) {
    sellerOrderConnection(
      filter: $filter
      first: $first
      after: $after
      before: $before
      sellerOrderStatus: $sellerOrderStatus
      orderedAfter: $orderedAfter
      orderedBefore: $orderedBefore
      totalMin: $totalMin
      totalMax: $totalMax
    ) {
      count
      edges {
        node {
          id
          idAlias
          total
          items {
            productId
            title
            quantity
          }
          orderDate
          status
          __typename
        }
        __typename
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
  }
`);

/**
 * How many orders sit in one status. Used by the list header to offer the
 * review queue, and by the queue itself for its segment counts — asking for a
 * single row because only the count is wanted.
 */
export const ORDER_STATUS_COUNT_QUERY = graphql(`
  query SellerOrderStatusCount($sellerOrderStatus: [SellerOrderStatus!]) {
    sellerOrderConnection(first: 1, sellerOrderStatus: $sellerOrderStatus) {
      count
    }
  }
`);
